import { FC } from 'react';

import {
    CircleDot,
    Cog,
    Droplet,
    Dumbbell,
    Eye,
    Flame,
    Leaf,
    LucideIcon,
    Moon,
    Shield,
    Sparkles,
    Star,
    Zap,
} from 'lucide-react';

import { cn } from '../../../utils';

interface Props {
    readonly iconKey: string;
    readonly className?: string;
}

interface IconDefinition {
    icon: LucideIcon;
    background: string;
    foreground: string;
}

const ICONS: Record<string, IconDefinition> = {
    pokemon_type_grass: {
        icon: Leaf,
        background: '#5aa85a',
        foreground: '#ffffff',
    },
    pokemon_type_fire: {
        icon: Flame,
        background: '#e65342',
        foreground: '#ffffff',
    },
    pokemon_type_water: {
        icon: Droplet,
        background: '#3f8ed0',
        foreground: '#ffffff',
    },
    pokemon_type_lightning: {
        icon: Zap,
        background: '#f3cf3f',
        foreground: '#3f3413',
    },
    pokemon_type_psychic: {
        icon: Eye,
        background: '#9b58a6',
        foreground: '#ffffff',
    },
    pokemon_type_fighting: {
        icon: Dumbbell,
        background: '#bd7941',
        foreground: '#ffffff',
    },
    pokemon_type_darkness: {
        icon: Moon,
        background: '#30313a',
        foreground: '#ffffff',
    },
    pokemon_type_metal: {
        icon: Cog,
        background: '#9ba7ae',
        foreground: '#20272b',
    },
    pokemon_type_fairy: {
        icon: Sparkles,
        background: '#df79b0',
        foreground: '#ffffff',
    },
    pokemon_type_dragon: {
        icon: Shield,
        background: '#d3ad34',
        foreground: '#3e3210',
    },
    pokemon_type_colorless: {
        icon: Star,
        background: '#d8dadd',
        foreground: '#41464d',
    },
};

export const PokemonOptionIcon: FC<Props> = ({ iconKey, className }) => {
    const definition = ICONS[iconKey];
    const Icon = definition?.icon ?? CircleDot;

    return (
        <span
            aria-hidden="true"
            className={cn(
                'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-black/15 shadow-[inset_0_1px_1px_rgba(255,255,255,0.4),0_1px_2px_rgba(0,0,0,0.18)]',
                className,
            )}
            style={
                definition
                    ? {
                          backgroundColor: definition.background,
                          color: definition.foreground,
                      }
                    : undefined
            }
        >
            <Icon className="h-4 w-4" strokeWidth={2.25} />
        </span>
    );
};
